
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1189:333)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.111 20.55h1.778l-2.667 3.15-2.666-3.15h1.777v-3.6h1.778v3.6zm-5.333-5.4H27L29.667 12l2.666 3.15h-1.777v3.6h-1.778v-3.6zM22.944 28h-6.722v2.5h3.056V33h2.444v-2.5h1.222c.81 0 1.588-.33 2.161-.915.573-.586.895-1.381.895-2.21s-.322-1.624-.895-2.21a3.021 3.021 0 00-2.16-.915h-4.89a.604.604 0 01-.432-.183.632.632 0 010-.884.604.604 0 01.433-.183h6.722v-2.5h-3.056V18h-2.444v2.5h-1.222c-.81 0-1.588.33-2.161.915a3.161 3.161 0 00-.895 2.21c0 .829.322 1.624.895 2.21.573.586 1.35.915 2.16.915h4.89c.162 0 .317.066.432.183a.632.632 0 010 .884.604.604 0 01-.433.183z","fill":"#06F"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1189:333","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1189:333"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1189:333","result":"shape"}})])])])
          )
        }
      }
    